import React from 'react';
import { Button, CircularProgress } from '@mui/material';

const LoadingButton = ({
  loading = false,
  loadingLabel = 'Loading',
  disabled = false,
  children,
  startIcon,
  ...buttonProps
}) => {
  const isDisabled = disabled || loading;

  return (
    <Button
      {...buttonProps}
      disabled={isDisabled}
      aria-busy={loading || undefined}
      startIcon={loading ? <CircularProgress size={18} color="inherit" /> : startIcon}
    >
      {loading ? loadingLabel : children}
    </Button>
  );
};

export default LoadingButton;
